module.exports = ".summary-container {\n  width: calc(100% - 40px);\n  margin: 0 auto; }\n"